




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { MapGameRole } from '@/core/constants';

import OnlinePlayerGrid from '@/components/OnlinePlayerGridOne.vue';
import { RealmsModule } from '@/store/modules/realms/realms.store';

import Statistics from '@/components/dashboard/realms/CharacterStatistics.vue';
import { Role } from '@/core/security/Role';
import { DeleteRealmRequest, Realm } from '@/types/apiServerContract';

@Component({
    components: {
        OnlinePlayerGrid,
        Statistics
    }
})
export default class SimpleRealmOverlay extends Vue {
	@Prop() realm!: Realm;

	get CanDeleterealm(): boolean {
	    return UserModule.user?.HasRole([Role.SuperAdmin]) ?? false;
	}

	GetSecurityName(sec: number) {
	    return MapGameRole(sec);
	}

	async DeleteRealm() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this realm?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    const request: DeleteRealmRequest = {
	        id: this.realm.id
	    };

	    await RealmsModule.DeleteRealm(request);

	    this.$bvToast.toast('Realm deleted successfully', {
	        variant: 'success',
	        title: 'Success'
	    });
	}
}
